export const IMAGE_ANNOTATIONS_PLACEHOLDER_TEXT = 'Type something';
